(function () {
  var SELECTORS = {
    dataScript:   '#rdv-reviews-json',
    config:       '#rdv-reviews-config',
    header:       '#rdv-reviews-header',
    filters:      '#rdv-filters',
    photosOuter:  '#rdv-reviews-photos-outer',
  };

  var PHOTOS_PER_PAGE_MOBILE   = 3;
  var PHOTOS_PER_PAGE_DESKTOP  = 5;

  // Custom review list (rendered from the full fetched dataset)
  // ┌─────────────────────────────────────────────────────────────────────┐
  // │ Number of reviews shown per page. Change this value to show more or  │
  // │ fewer reviews on each page of the reviews page.                      │
  // └─────────────────────────────────────────────────────────────────────┘
  var REVIEWS_PER_PAGE   = 10;
  var CAP_PER_PRODUCT    = 30;   // max reviews kept in memory per product (scalability cap)
  var MAX_FETCH_PAGES    = 30;   // safety bound on number of API pages fetched
  var REVIEWS_ENDPOINT   = 'https://cdn.judge.me/reviews/all_reviews_js_based';

  // Valeurs par défaut en français — remplacées par config.labels (injectés via Liquid) si disponibles
  var WRITE_REVIEW_LABELS = {
    // Actions du formulaire
    open:          'Laisser un avis client',
    close:         'Annuler',
    submit:        'Envoyer',
    submitting:    'Envoi en cours…',
    success:       'Merci pour votre avis ! Il sera publié après modération.',
    error:         'Une erreur est survenue. Veuillez réessayer.',
    noRating:      'Veuillez sélectionner une note.',
    required:      'Veuillez remplir tous les champs obligatoires.',
    photoTooBig:   'La photo dépasse 10 Mo. Veuillez en choisir une plus petite.',
    uploading:     'Envoi de la photo…',
    // Libellés des champs
    yourRating:    'Votre note',
    selectRating:  'Sélectionner une note',
    firstName:     'Prénom',
    emailLabel:    'Email',
    reviewTitle:   "Titre de l'avis",
    yourReview:    'Votre avis',
    addPhoto:      'Ajouter une photo',
    optional:      '(optionnel)',
    choosePhoto:   'Choisir une photo',
    removePhoto:   'Supprimer la photo',
    // En-tête
    basedOn:       'Basé sur %count% avis',
    // Galerie photos
    photosTitle:   'Photos & vidéos clients',
    previous:      'Précédent',
    next:          'Suivant',
    closeLightbox: 'Fermer',
    // Chargement mobile
    loadMore:      "Voir plus d'avis",
    // Note champs obligatoires
    requiredNote:  '* Champs obligatoires',
    // Filtres produit
    filterAll:     'Tous les produits',
    // Sélecteur produit
    productLabel:       'Produit *',
    productPlaceholder: 'Sélectionnez un produit',
    productRequired:    'Veuillez sélectionner un produit.',
    storeGeneral:       'La boutique en général',
  };

  // Module-level state for the custom review list
  var _allReviews   = [];   // full fetched dataset, capped at CAP_PER_PRODUCT per product
  var _activeFilter = null; // null = all products; string = normalised product title (uppercase)
  var _currentPage  = 1;    // active page in the numbered pagination
  var _config       = {};   // shared config reference
  var _lightboxOpen = function () {}; // set by _initLightbox(); shared by photos gallery + review media

  var WRITE_REVIEW_API_URL         = 'https://api.judge.me/api/v1/reviews';
  var WRITE_REVIEW_PRESIGNED_URL   = 'https://api.judge.me/api/v1/pictures/presigned_data';
  var WRITE_REVIEW_PHOTO_MAX_BYTES = 10 * 1024 * 1024; // 10 MB — limite S3 de Judge.me

  function _getPhotosPerPage() {
    return window.matchMedia('(max-width: 699px)').matches
      ? PHOTOS_PER_PAGE_MOBILE
      : PHOTOS_PER_PAGE_DESKTOP;
  }

  function _renderStars(rating) {
    var full  = Math.floor(rating);
    var half  = (rating - full) >= 0.5;
    var empty = 5 - full - (half ? 1 : 0);
    var html  = '<span class="rdv-stars">';
    for (var i = 0; i < full; i++)  html += '<span class="rdv-star rdv-star--full">★</span>';
    if (half) html += '<span class="rdv-star rdv-star--half"><span class="rdv-star__fill">★</span><span class="rdv-star__empty">★</span></span>';
    for (var j = 0; j < empty; j++) html += '<span class="rdv-star rdv-star--empty">★</span>';
    html += '</span>';
    return html;
  }

  function _buildHistogram(histogram) {
    return histogram.map(function (item) {
      return (
        '<div class="rdv-reviews-header__bar-row">' +
          '<span class="rdv-reviews-header__bar-label">' + item.rating + ' ★</span>' +
          '<div class="rdv-reviews-header__bar-track">' +
            '<div class="rdv-reviews-header__bar-fill" style="width:' + item.percentage + '%"></div>' +
          '</div>' +
          '<span class="rdv-reviews-header__bar-count">' + item.frequency + '</span>' +
        '</div>'
      );
    }).join('');
  }

  function _buildPhotos(photoGallery) {
    if (!photoGallery || !photoGallery.length) return '';

    var items = photoGallery.filter(function (item) {
      return item.pictures_urls && item.pictures_urls[0] && item.pictures_urls[0].compact;
    });
    if (!items.length) return '';

    var perPage  = _getPhotosPerPage();
    var hasMore  = items.length > perPage;

    var photosHtml = items.map(function (item, index) {
      var compact  = item.pictures_urls[0].compact;
      var original = item.pictures_urls[0].original || compact;
      var hidden   = index >= perPage ? ' rdv-reviews-photos__item--hidden' : '';
      return (
        '<div class="rdv-reviews-photos__item' + hidden + '" data-index="' + index + '">' +
          '<img src="' + compact + '"' +
               ' alt="' + (item.reviewer_name || '') + '"' +
               ' data-original="' + original + '"' +
               ' loading="lazy" width="100" height="100">' +
        '</div>'
      );
    }).join('');

    var prevBtn = hasMore
      ? '<button class="rdv-reviews-photos__btn rdv-reviews-photos__btn--prev rdv-reviews-photos__btn--invisible" aria-label="' + WRITE_REVIEW_LABELS.previous + '">&#8249;</button>'
      : '';
    var nextBtn = hasMore
      ? '<button class="rdv-reviews-photos__btn rdv-reviews-photos__btn--next" aria-label="' + WRITE_REVIEW_LABELS.next + '">&#8250;</button>'
      : '';

    return (
      '<div class="rdv-reviews-photos">' +
        '<div class="rdv-reviews-photos__slider">' +
          prevBtn +
          '<div class="rdv-reviews-photos__grid">' + photosHtml + '</div>' +
          nextBtn +
        '</div>' +
      '</div>'
    );
  }

  function _buildHeader(data) {
    var avg    = parseFloat(data.average_rating);
    var count  = data.number_of_product_reviews;
    var shopId = (data.all_reviews && data.all_reviews[0]) ? data.all_reviews[0].encoded_shop_id : '';

    return (
      '<div class="rdv-reviews-header__top">' +
        '<div class="rdv-reviews-header__rating">' +
          '<div class="rdv-reviews-header__stars">' + _renderStars(avg) + '</div>' +
          '<div class="rdv-reviews-header__score">' + avg.toFixed(2) + '</div>' +
          '<div class="rdv-reviews-header__count">' + WRITE_REVIEW_LABELS.basedOn.replace('%count%', count) + '</div>' +
        '</div>' +
        '<div class="rdv-reviews-header__histogram">' +
          _buildHistogram(data.histogram) +
        '</div>' +
        '<div class="rdv-reviews-header__action">' +
          '<button type="button" class="rdv-reviews-header__write-btn">' +
            WRITE_REVIEW_LABELS.open +
          '</button>' +
        '</div>' +
      '</div>'
    );
  }

  function _initSlider(headerEl) {
    var grid = headerEl.querySelector('.rdv-reviews-photos__grid');
    if (!grid) return;

    var items      = Array.prototype.slice.call(grid.querySelectorAll('.rdv-reviews-photos__item'));
    var total      = items.length;
    var perPage    = _getPhotosPerPage();
    if (total <= perPage) return;

    var totalPages  = Math.ceil(total / perPage);
    var currentPage = 0;
    var prevBtn     = headerEl.querySelector('.rdv-reviews-photos__btn--prev');
    var nextBtn     = headerEl.querySelector('.rdv-reviews-photos__btn--next');

    function _showPage(page) {
      items.forEach(function (item, i) {
        var visible = i >= page * perPage && i < (page + 1) * perPage;
        item.classList.toggle('rdv-reviews-photos__item--hidden', !visible);
      });
      if (prevBtn) prevBtn.classList.toggle('rdv-reviews-photos__btn--invisible', page === 0);
      if (nextBtn) nextBtn.classList.toggle('rdv-reviews-photos__btn--invisible', page >= totalPages - 1);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (currentPage > 0) { currentPage--; _showPage(currentPage); }
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (currentPage < totalPages - 1) { currentPage++; _showPage(currentPage); }
      });
    }
  }

  /**
   * Creates the lightbox DOM once and exposes _lightboxOpen(src, alt).
   * Shared by the customer-photos gallery and the review-media thumbnails.
   */
  function _initLightbox() {
    if (document.querySelector('.rdv-lightbox')) return;

    var lightbox = document.createElement('div');
    lightbox.className = 'rdv-lightbox';
    lightbox.innerHTML =
      '<div class="rdv-lightbox__overlay"></div>' +
      '<div class="rdv-lightbox__content">' +
        '<img class="rdv-lightbox__img" src="" alt="">' +
        '<button class="rdv-lightbox__close" aria-label="' + WRITE_REVIEW_LABELS.closeLightbox + '">&times;</button>' +
      '</div>';
    document.body.appendChild(lightbox);

    var overlay  = lightbox.querySelector('.rdv-lightbox__overlay');
    var imgEl    = lightbox.querySelector('.rdv-lightbox__img');
    var closeBtn = lightbox.querySelector('.rdv-lightbox__close');

    function _close() {
      lightbox.classList.remove('rdv-lightbox--open');
      document.body.style.overflow = '';
      imgEl.src = '';
    }

    _lightboxOpen = function (src, alt) {
      imgEl.src = src;
      imgEl.alt = alt || '';
      lightbox.classList.add('rdv-lightbox--open');
      document.body.style.overflow = 'hidden';
    };

    overlay.addEventListener('click', _close);
    closeBtn.addEventListener('click', _close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') _close();
    });
  }

  function _buildForm(config) {
    var starBtns = [1, 2, 3, 4, 5].map(function (v) {
      return (
        '<button type="button" class="rdv-wr-form__star" data-value="' + v + '"' +
               ' aria-label="' + v + ' étoile' + (v > 1 ? 's' : '') + '">★</button>'
      );
    }).join('');

    var productOptions = (config.products || []).map(function (p) {
      return '<option value="' + p.id + '">' + p.title.replace(/</g, '&lt;').replace(/>/g, '&gt;') + '</option>';
    }).join('');

    return (
      '<form class="rdv-wr-form__inner" novalidate>' +
        '<div class="rdv-wr-form__top-row">' +
          '<div class="rdv-wr-form__stars-group">' +
            '<p class="rdv-wr-form__label">' + WRITE_REVIEW_LABELS.yourRating + ' <span aria-hidden="true">*</span></p>' +
            '<div class="rdv-wr-form__stars" role="group" aria-label="' + WRITE_REVIEW_LABELS.selectRating + '">' +
              starBtns +
            '</div>' +
          '</div>' +
          '<div class="rdv-wr-form__field rdv-wr-form__field--photo">' +
            '<label class="rdv-wr-form__label" for="rdv-wr-photo">' + WRITE_REVIEW_LABELS.addPhoto + '</label>' +
            '<label class="rdv-wr-form__file-label" for="rdv-wr-photo">' +
              '<span class="rdv-wr-form__file-text">' + WRITE_REVIEW_LABELS.choosePhoto + '</span>' +
              '<input class="rdv-wr-form__file" type="file" id="rdv-wr-photo" name="photo" accept="image/*">' +
            '</label>' +
            '<div class="rdv-wr-form__photo-preview" hidden></div>' +
          '</div>' +
        '</div>' +
        '<div class="rdv-wr-form__field">' +
          '<label class="rdv-wr-form__label" for="rdv-wr-product">' + WRITE_REVIEW_LABELS.productLabel + '</label>' +
          '<select class="rdv-wr-form__select" id="rdv-wr-product" name="product" required>' +
          '<option value="" disabled selected>' + WRITE_REVIEW_LABELS.productPlaceholder + '</option>' +
          productOptions +
          '</select>' +
        '</div>' +
        '<div class="rdv-wr-form__row">' +
          '<div class="rdv-wr-form__field">' +
            '<label class="rdv-wr-form__label" for="rdv-wr-name">' + WRITE_REVIEW_LABELS.firstName + ' <span aria-hidden="true">*</span></label>' +
            '<input class="rdv-wr-form__input" type="text" id="rdv-wr-name" name="name" required autocomplete="given-name">' +
          '</div>' +
          '<div class="rdv-wr-form__field">' +
            '<label class="rdv-wr-form__label" for="rdv-wr-email">' + WRITE_REVIEW_LABELS.emailLabel + ' <span aria-hidden="true">*</span></label>' +
            '<input class="rdv-wr-form__input" type="email" id="rdv-wr-email" name="email" required autocomplete="email">' +
          '</div>' +
        '</div>' +
        '<div class="rdv-wr-form__field">' +
          '<label class="rdv-wr-form__label" for="rdv-wr-title">' + WRITE_REVIEW_LABELS.reviewTitle + '</label>' +
          '<input class="rdv-wr-form__input" type="text" id="rdv-wr-title" name="title">' +
        '</div>' +
        '<div class="rdv-wr-form__field">' +
          '<label class="rdv-wr-form__label" for="rdv-wr-body">' + WRITE_REVIEW_LABELS.yourReview + ' <span aria-hidden="true">*</span></label>' +
          '<textarea class="rdv-wr-form__textarea" id="rdv-wr-body" name="body" rows="5" required></textarea>' +
        '</div>' +

        '<div class="rdv-wr-form__bottom-row">' +
          '<div class="rdv-wr-form__footer">' +
            '<button type="submit" class="rdv-wr-form__submit">' + WRITE_REVIEW_LABELS.submit + '</button>' +
            '<p class="rdv-wr-form__message" hidden></p>' +
          '</div>' +
          '<p class="rdv-wr-form__required-note">' + WRITE_REVIEW_LABELS.requiredNote + '</p>' +
        '</div>' +
      '</form>'
    );
  }

  function _uploadPhoto(file, config) {
    return fetch(
      WRITE_REVIEW_PRESIGNED_URL +
      '?api_token='   + encodeURIComponent(config.apiToken) +
      '&shop_domain=' + encodeURIComponent(config.shopDomain) +
      '&platform=shopify'
    )
      .then(function (r) { return r.json(); })
      .then(function (presigned) {
        var fd  = new FormData();
        var key = presigned.key_prefix + file.name.replace(/[^a-zA-Z0-9._-]/g, '_');
        fd.append('key',                    key);
        fd.append('acl',                    presigned.fields.acl);
        fd.append('success_action_status',  presigned.fields.success_action_status);
        fd.append('policy',                 presigned.fields.policy);
        fd.append('x-amz-credential',       presigned.fields['x-amz-credential']);
        fd.append('x-amz-algorithm',        presigned.fields['x-amz-algorithm']);
        fd.append('x-amz-date',             presigned.fields['x-amz-date']);
        fd.append('x-amz-signature',        presigned.fields['x-amz-signature']);
        fd.append('file',                   file);
        return fetch(presigned.url, { method: 'POST', body: fd })
          .then(function (r) { return r.text(); })
          .then(function (xml) {
            var match = xml.match(/<Key>([^<]+)<\/Key>/);
            if (!match) throw new Error('S3 upload failed');
            return match[1];
          });
      });
  }

  function _initWriteReviewToggle(headerEl, config) {
    var btn = headerEl.querySelector('.rdv-reviews-header__write-btn');
    if (!btn || !config.apiToken) return;

    // Fallback shop domain from jdgm global if Liquid didn't populate it
    if (!config.shopDomain) {
      try {
        var p = jdgm.ajaxParamsFor(jdgm.$('.jdgm-widget'));
        config.shopDomain = p.shop_domain || '';
      } catch (e) { config.shopDomain = ''; }
    }
    if (!config.shopDomain) return;

    // Form wrapper — inserted as next sibling of the header card
    var formWrap = document.createElement('div');
    formWrap.className = 'rdv-write-review-frame';
    formWrap.setAttribute('aria-hidden', 'true');
    formWrap.innerHTML = _buildForm(config);
    headerEl.parentNode.insertBefore(formWrap, headerEl.nextSibling);

    var form         = formWrap.querySelector('.rdv-wr-form__inner');
    var starsEl      = formWrap.querySelector('.rdv-wr-form__stars');
    var stars        = Array.prototype.slice.call(starsEl.querySelectorAll('.rdv-wr-form__star'));
    var msgEl        = formWrap.querySelector('.rdv-wr-form__message');
    var submitBtn    = formWrap.querySelector('.rdv-wr-form__submit');
    var fileInput    = formWrap.querySelector('.rdv-wr-form__file');
    var fileText     = formWrap.querySelector('.rdv-wr-form__file-text');
    var photoPreview = formWrap.querySelector('.rdv-wr-form__photo-preview');
    var isOpen       = false;
    var rating       = 0;

    // ── Photo preview ──────────────────────────────────────────────────────────
    fileInput.addEventListener('change', function () {
      var file = fileInput.files[0];
      if (!file) { photoPreview.hidden = true; photoPreview.innerHTML = ''; return; }
      var reader = new FileReader();
      reader.onload = function (ev) {
        photoPreview.hidden = false;
        photoPreview.innerHTML =
          '<img class="rdv-wr-form__photo-thumb" src="' + ev.target.result + '" alt="">' +
          '<button type="button" class="rdv-wr-form__photo-remove" aria-label="' + WRITE_REVIEW_LABELS.removePhoto + '">&times;</button>';
        photoPreview.querySelector('.rdv-wr-form__photo-remove').addEventListener('click', function () {
          fileInput.value = '';
          fileText.textContent = WRITE_REVIEW_LABELS.choosePhoto;
          photoPreview.hidden = true;
          photoPreview.innerHTML = '';
        });
      };
      fileText.textContent = file.name;
      reader.readAsDataURL(file);
    });

    // ── Toggle open / close ──────────────────────────────────────────────────
    btn.addEventListener('click', function () {
      isOpen = !isOpen;
      formWrap.classList.toggle('rdv-write-review-frame--open', isOpen);
      formWrap.setAttribute('aria-hidden', String(!isOpen));
      btn.textContent = isOpen ? WRITE_REVIEW_LABELS.close : WRITE_REVIEW_LABELS.open;
      btn.classList.toggle('rdv-reviews-header__write-btn--active', isOpen);
      if (isOpen) {
        setTimeout(function () {
          headerEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 50);
      }
    });

    // ── Star rating ──────────────────────────────────────────────────────────
    function _setRating(val) {
      rating = val;
      stars.forEach(function (s, i) {
        s.classList.toggle('rdv-wr-form__star--selected', i < val);
      });
    }

    stars.forEach(function (star) {
      star.addEventListener('click', function () {
        _setRating(parseInt(star.dataset.value, 10));
      });
      star.addEventListener('mouseenter', function () {
        var val = parseInt(star.dataset.value, 10);
        stars.forEach(function (s, i) {
          s.classList.toggle('rdv-wr-form__star--hover', i < val);
        });
      });
    });

    starsEl.addEventListener('mouseleave', function () {
      stars.forEach(function (s) { s.classList.remove('rdv-wr-form__star--hover'); });
    });

    // ── Form submit ──────────────────────────────────────────────────────────
    function _showMessage(text, type) {
      msgEl.textContent = text;
      msgEl.hidden = false;
      msgEl.className = 'rdv-wr-form__message rdv-wr-form__message--' + type;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      if (!rating) { _showMessage(WRITE_REVIEW_LABELS.noRating, 'error'); return; }

      var name      = form.querySelector('[name="name"]').value.trim();
      var email     = form.querySelector('[name="email"]').value.trim();
      var title     = form.querySelector('[name="title"]').value.trim();
      var body      = form.querySelector('[name="body"]').value.trim();
      var productId = form.querySelector('[name="product"]').value || null;
      var photoFile = fileInput.files[0] || null;

      if (!productId) {
        _showMessage(WRITE_REVIEW_LABELS.productRequired, 'error');
        return;
      }

      if (!name || !email || !body) {
        _showMessage(WRITE_REVIEW_LABELS.required, 'error');
        return;
      }

      if (photoFile && photoFile.size > WRITE_REVIEW_PHOTO_MAX_BYTES) {
        _showMessage(WRITE_REVIEW_LABELS.photoTooBig, 'error');
        return;
      }

      submitBtn.disabled = true;
      msgEl.hidden       = true;

      function _submitReview(pictureKeys) {
        // Use FormData (multipart/form-data) instead of JSON so the browser
        // sends a "simple" CORS request — no preflight OPTIONS needed.
        // This matches how Judge.me's own widget submits reviews.
        var fd = new FormData();
        fd.append('api_token',   config.apiToken);
        fd.append('shop_domain', config.shopDomain);
        fd.append('platform',    'shopify');
        fd.append('name',        name);
        fd.append('email',       email);
        fd.append('rating',      rating);
        fd.append('title',       title);
        fd.append('body',        body);
        if (productId) fd.append('product_id', parseInt(productId, 10));
        if (pictureKeys && pictureKeys.length) {
          pictureKeys.forEach(function (k) { fd.append('picture_keys[]', k); });
        }

        return fetch(WRITE_REVIEW_API_URL, {
          method: 'POST',
          body:   fd,
        }).then(function (res) { return res.json(); });
      }

      function _onSuccess() {
        _showMessage(WRITE_REVIEW_LABELS.success, 'success');
        form.reset();
        _setRating(0);
        photoPreview.hidden    = true;
        photoPreview.innerHTML = '';
        fileText.textContent   = WRITE_REVIEW_LABELS.choosePhoto;
        submitBtn.textContent  = WRITE_REVIEW_LABELS.submit;
      }

      function _onError() {
        _showMessage(WRITE_REVIEW_LABELS.error, 'error');
        submitBtn.textContent = WRITE_REVIEW_LABELS.submit;
        submitBtn.disabled    = false;
      }

      function _handleResponse(json) {
        if (json.review || json.id || json.message || json.success) {
          _onSuccess();
        } else {
          var errs = json.errors || json.error;
          var msg  = Array.isArray(errs) ? errs.join(', ') : (errs || WRITE_REVIEW_LABELS.error);
          _showMessage(msg, 'error');
          submitBtn.textContent = WRITE_REVIEW_LABELS.submit;
          submitBtn.disabled    = false;
        }
      }

      if (photoFile) {
        submitBtn.textContent = WRITE_REVIEW_LABELS.uploading;
        _uploadPhoto(photoFile, config)
          .then(function (key) {
            submitBtn.textContent = WRITE_REVIEW_LABELS.submitting;
            return _submitReview([key]);
          })
          .then(_handleResponse)
          .catch(_onError);
      } else {
        submitBtn.textContent = WRITE_REVIEW_LABELS.submitting;
        _submitReview([])
          .then(_handleResponse)
          .catch(_onError);
      }
    });
  }

  // ── Custom review list ───────────────────────────────────────────────────

  function _esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /**
   * Builds the HTML for a single review card from a Judge.me review object.
   * Photo (if any) goes to the right on desktop / below on mobile (CSS-driven).
   */
  function _renderReviewCard(r) {
    var pic      = (Array.isArray(r.pictures_urls) && r.pictures_urls[0]) ? r.pictures_urls[0] : null;
    var hasPhoto = !!(pic && (pic.compact || pic.original));
    var initial  = (r.reviewer_initial || (r.reviewer_name || '?').charAt(0) || '?').toUpperCase();
    var date     = _formatDate(r.created_at);

    var productThumb = r.product_pictures_url
      ? '<span class="rdv-rev__product-thumb"><img src="' + _esc(r.product_pictures_url) + '" alt="" loading="lazy" width="40" height="40"></span>'
      : '';

    var media = '';
    if (hasPhoto) {
      var thumb = pic.compact || pic.small || pic.original;
      var full  = pic.original || pic.huge || thumb;
      media = '<div class="rdv-rev__media">' +
                '<img src="' + _esc(thumb) + '" data-original="' + _esc(full) + '" alt="" loading="lazy">' +
              '</div>';
    }

    return (
      '<article class="rdv-rev' + (hasPhoto ? ' rdv-rev--has-photo' : '') + '">' +
        '<a class="rdv-rev__product" href="' + _esc(r.product_url || '#') + '">' +
          productThumb +
          '<span class="rdv-rev__product-label">' + _esc(WRITE_REVIEW_LABELS.reviewFor) +
            ' <span class="rdv-rev__product-name">' + _esc(r.product_title || '') + '</span>' +
          '</span>' +
        '</a>' +
        '<div class="rdv-rev__main">' +
          '<div class="rdv-rev__head">' +
            '<span class="rdv-rev__avatar">' + _esc(initial) + '</span>' +
            '<div class="rdv-rev__meta">' +
              '<span class="rdv-rev__name">' + _esc(r.reviewer_name || '') + '</span>' +
              _renderStars(r.rating) +
            '</div>' +
            (date ? '<time class="rdv-review-date">' + date + '</time>' : '') +
          '</div>' +
          (r.title ? '<p class="rdv-rev__title">' + _esc(r.title) + '</p>' : '') +
          '<div class="rdv-rev__body">' + (r.body_html || _esc(r.body || '')) + '</div>' +
        '</div>' +
        media +
      '</article>'
    );
  }

  /** Returns the reviews matching the active filter (or all if none). */
  function _filteredReviews() {
    if (!_activeFilter) return _allReviews;
    return _allReviews.filter(function (r) {
      return _normTitle(r.product_title) === _activeFilter;
    });
  }

  /** Builds the numbered pagination controls (‹ 1 2 3 … ›). */
  function _buildPagination(totalPages) {
    if (totalPages <= 1) return '';

    function navBtn(page, disabled, label, glyph) {
      return '<button type="button" class="rdv-pagination__btn rdv-pagination__btn--nav" ' +
        'data-page="' + page + '"' + (disabled ? ' disabled' : '') +
        ' aria-label="' + _esc(label) + '">' + glyph + '</button>';
    }

    var btns = navBtn(_currentPage - 1, _currentPage === 1, WRITE_REVIEW_LABELS.previous, '&#8249;');
    for (var p = 1; p <= totalPages; p++) {
      btns += '<button type="button" class="rdv-pagination__btn rdv-pagination__btn--page' +
        (p === _currentPage ? ' rdv-pagination__btn--active' : '') +
        '" data-page="' + p + '">' + p + '</button>';
    }
    btns += navBtn(_currentPage + 1, _currentPage === totalPages, WRITE_REVIEW_LABELS.next, '&#8250;');

    return '<nav class="rdv-pagination">' + btns + '</nav>';
  }

  /** Renders the current page of the filtered reviews + pagination controls. */
  function _renderList() {
    var listEl = document.getElementById('rdv-review-list');
    if (!listEl) return;

    var reviews    = _filteredReviews();
    var totalPages = Math.max(1, Math.ceil(reviews.length / REVIEWS_PER_PAGE));
    if (_currentPage > totalPages) _currentPage = totalPages;

    var start = (_currentPage - 1) * REVIEWS_PER_PAGE;
    var cards = reviews.slice(start, start + REVIEWS_PER_PAGE).map(_renderReviewCard).join('');

    listEl.innerHTML =
      '<div class="rdv-review-list__items">' + cards + '</div>' +
      _buildPagination(totalPages);
  }

  /** Smoothly scrolls back to the top of the list (used on page change). */
  function _scrollToListTop() {
    var target = document.querySelector(SELECTORS.filters) || document.getElementById('rdv-review-list');
    if (!target) return;
    window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - 100, behavior: 'smooth' });
  }

  /** One delegated handler for pagination clicks and media lightbox triggers. */
  function _initListInteractions(listEl) {
    listEl.addEventListener('click', function (e) {
      var pageBtn = e.target.closest('.rdv-pagination__btn');
      if (pageBtn && !pageBtn.disabled) {
        var page = parseInt(pageBtn.dataset.page, 10);
        if (page && page !== _currentPage) {
          _currentPage = page;
          _renderList();
          _scrollToListTop();
        }
        return;
      }
      var img = e.target.closest('.rdv-rev__media img');
      if (img) _lightboxOpen(img.dataset.original || img.src, img.alt);
    });
  }

  // ── Fresh widget data ──────────────────────────────────────────────────────

  /**
   * Fallback for the header/photos data when the metafield JSON island is
   * absent: polls until `jdgm.data.allReviewsWidgetV2025` is populated.
   * Calls `callback(data)` when ready, or `callback(null)` after MAX_WAIT ms.
   */
  function _waitForWidgetData(callback) {
    var MAX_WAIT = 15000;
    var INTERVAL = 300;
    var elapsed  = 0;

    function _check() {
      var d = window.jdgm && jdgm.data && jdgm.data.allReviewsWidgetV2025;
      if (d && Array.isArray(d.all_reviews)) {
        callback(d);
        return;
      }
      elapsed += INTERVAL;
      if (elapsed >= MAX_WAIT) { callback(null); return; }
      setTimeout(_check, INTERVAL);
    }
    _check();
  }

  function _formatDate(isoStr) {
    if (!isoStr) return '';
    var d = new Date(isoStr);
    if (isNaN(d)) return '';
    return String(d.getDate()).padStart(2, '0') + '/' +
           String(d.getMonth() + 1).padStart(2, '0') + '/' +
           d.getFullYear();
  }

  /**
   * Returns the short product name (strips the " - 50 mL" variant suffix).
   * Used to normalise product titles for matching.
   */
  function _shortTitle(title) {
    return (title || '').replace(/\s*[-–]\s*\d+\s*m[Ll]\s*$/i, '').trim();
  }

  /** Uppercase short title — the key used to group/filter reviews by product. */
  function _normTitle(title) {
    return _shortTitle(title).toUpperCase();
  }

  // ── Fetch + filter ───────────────────────────────────────────────────────

  function _buildEndpointUrl(shopDomain, page) {
    var params = new URLSearchParams({
      widget_type:          'all-reviews-widget-v2025',
      sort_by:              'created_at',
      sort_dir:             'desc',
      skip_other_languages: 'true',
      widget_theme:         'default',
      shop_domain:          shopDomain,
      platform:             'shopify',
      page:                 String(page)
    });
    return REVIEWS_ENDPOINT + '?' + params.toString();
  }

  function _fetchPage(shopDomain, page) {
    return fetch(_buildEndpointUrl(shopDomain, page), { credentials: 'omit' })
      .then(function (res) { return res.ok ? res.json() : null; })
      .catch(function () { return null; });
  }

  /**
   * Fetches every review page in parallel (bounded by MAX_FETCH_PAGES) and
   * returns a flat, date-sorted array capped at CAP_PER_PRODUCT per product.
   * Store-level reviews are skipped (we only show product reviews here).
   */
  function _fetchAllReviews(shopDomain) {
    if (!shopDomain) return Promise.resolve([]);

    return _fetchPage(shopDomain, 1).then(function (first) {
      if (!first || !Array.isArray(first.reviews)) return [];

      var totalPages = Math.min(
        (first.pagination && first.pagination.total_pages) || 1,
        MAX_FETCH_PAGES
      );

      var pending = [Promise.resolve(first.reviews)];
      for (var page = 2; page <= totalPages; page++) {
        pending.push(_fetchPage(shopDomain, page).then(function (json) {
          return (json && Array.isArray(json.reviews)) ? json.reviews : [];
        }));
      }

      return Promise.all(pending).then(function (chunks) {
        var perProduct = {};
        var collected  = [];
        chunks.forEach(function (chunk) {
          chunk.forEach(function (r) {
            if (r.is_shop_review) return;
            var key = _normTitle(r.product_title);
            if (!key) return;
            perProduct[key] = perProduct[key] || 0;
            if (perProduct[key] >= CAP_PER_PRODUCT) return;
            perProduct[key]++;
            collected.push(r);
          });
        });
        return collected;
      });
    });
  }

  /**
   * Distinct products present in the dataset, ordered by _config.filterOrder.
   * Returns [{ key: normalisedTitle, label: shortTitle }].
   */
  function _deriveFilterProducts() {
    var seen  = {};
    var list  = [];
    _allReviews.forEach(function (r) {
      var key = _normTitle(r.product_title);
      if (!key || seen[key]) return;
      seen[key] = true;
      list.push({ key: key, label: _shortTitle(r.product_title) });
    });

    var order = (_config.filterOrder || []).map(function (o) { return o.toUpperCase(); });
    list.sort(function (a, b) {
      var ia = order.indexOf(a.key); if (ia === -1) ia = order.length;
      var ib = order.indexOf(b.key); if (ib === -1) ib = order.length;
      return ia - ib;
    });
    return list;
  }

  /**
   * Builds the HTML for the filter tab strip (underline style).
   * Includes a `.rdv-filters__indicator` span that JS slides under the active tab.
   */
  function _buildFilters(products) {
    var allBtn = (
      '<button type="button" class="rdv-filter-btn rdv-filter-btn--active" data-filter-key="">' +
        _esc(WRITE_REVIEW_LABELS.filterAll) +
      '</button>'
    );
    var productBtns = products.map(function (p) {
      return (
        '<button type="button" class="rdv-filter-btn" data-filter-key="' + _esc(p.key) + '">' +
          _esc(p.label) +
        '</button>'
      );
    }).join('');
    return allBtn + productBtns + '<span class="rdv-filters__indicator" aria-hidden="true"></span>';
  }

  /**
   * Wires up click handlers and the sliding underline indicator.
   */
  function _initFilterClicks(filtersEl) {
    var indicator = filtersEl.querySelector('.rdv-filters__indicator');

    function _moveIndicator(btn) {
      if (!indicator || !btn) return;
      indicator.style.left  = btn.offsetLeft + 'px';
      indicator.style.width = btn.offsetWidth + 'px';
    }

    // Position indicator on initial active button after layout is painted.
    setTimeout(function () {
      _moveIndicator(filtersEl.querySelector('.rdv-filter-btn--active'));
    }, 0);

    // Reposition on window resize (e.g. font scale change).
    window.addEventListener('resize', function () {
      _moveIndicator(filtersEl.querySelector('.rdv-filter-btn--active'));
    });

    filtersEl.addEventListener('click', function (e) {
      var btn = e.target.closest('.rdv-filter-btn');
      if (!btn) return;
      filtersEl.querySelectorAll('.rdv-filter-btn').forEach(function (b) {
        b.classList.toggle('rdv-filter-btn--active', b === btn);
      });
      _moveIndicator(btn);
      _activeFilter = btn.dataset.filterKey || null;
      _currentPage  = 1; // every tab change resets to the first page
      _renderList();
    });
  }

  /** Ensures _config.shopDomain is set (Liquid value, else jdgm fallback). */
  function _resolveShopDomain() {
    if (_config.shopDomain) return;
    try {
      var p = jdgm.ajaxParamsFor(jdgm.$('.jdgm-widget'));
      _config.shopDomain = p.shop_domain || '';
    } catch (e) {
      _config.shopDomain = '';
    }
  }

  function _renderHeaderAndPhotos(data, headerEl) {
    if (!data) return;
    var photosEl = document.querySelector(SELECTORS.photosOuter);
    if (photosEl) {
      photosEl.innerHTML = _buildPhotos(data.photo_gallery);
      _initSlider(photosEl);
      photosEl.addEventListener('click', function (e) {
        var img = e.target.closest('.rdv-reviews-photos__item img');
        if (img) _lightboxOpen(img.dataset.original || img.src, img.alt);
      });
    }
    headerEl.innerHTML = _buildHeader(data);
    _initWriteReviewToggle(headerEl, _config);
  }

  function init() {
    var headerEl  = document.querySelector(SELECTORS.header);
    var filtersEl = document.querySelector(SELECTORS.filters);
    var listEl    = document.getElementById('rdv-review-list');
    if (!headerEl) return;

    var configEl = document.querySelector(SELECTORS.config);
    if (configEl) {
      try { _config = JSON.parse(configEl.textContent); } catch (e) {}
    }

    // Merge labels from Liquid (supports Shopify translations via {{ 'key' | t }})
    if (_config.labels) {
      Object.keys(_config.labels).forEach(function (k) {
        WRITE_REVIEW_LABELS[k] = _config.labels[k];
      });
    }

    _resolveShopDomain();
    _initLightbox();
    if (listEl) _initListInteractions(listEl);

    // Header + customer-photos render from the metafield cache (or the widget
    // data as a fallback). The aggregate fields (rating, count, gallery) are
    // present regardless of how many reviews are sliced in.
    var dataEl = document.querySelector(SELECTORS.dataScript);
    var cachedData = null;
    if (dataEl) {
      try { cachedData = JSON.parse(dataEl.textContent); } catch (e) {}
    }
    if (cachedData) {
      _renderHeaderAndPhotos(cachedData, headerEl);
    } else {
      _waitForWidgetData(function (freshData) { _renderHeaderAndPhotos(freshData, headerEl); });
    }

    // The review list is rendered from the full fetched dataset (capped per
    // product), independent of the widget's server-side pagination.
    _fetchAllReviews(_config.shopDomain).then(function (reviews) {
      _allReviews = reviews || [];

      if (filtersEl) {
        var products = _deriveFilterProducts();
        // Only show tabs when more than one product actually has reviews.
        if (products.length > 1) {
          filtersEl.innerHTML = _buildFilters(products);
          _initFilterClicks(filtersEl);
        }
      }

      _renderList();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
